import { AgmCoreModule } from '@agm/core';
import { APP_INITIALIZER, Injector, NgModule, NO_ERRORS_SCHEMA  } from "@angular/core";
import { LOCATION_INITIALIZED } from "@angular/common";
import { HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxGoogleAnalyticsModule } from "ngx-google-analytics";
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { environment } from "src/environments/environment";
import { LayoutCommonComponent } from "./core/layout/layout-common/layout-common.component";
import { LayoutMainComponent } from './core/layout/layout-main/layout-main.component';
import { FilesizePipe } from "src/app/shared/pipes/filesize/filesize.pipe";
import { AuthInterceptor } from "src/app/core/services/auth-interceptor.service";
import { CustomModule } from "src/app/shared/custom.module";
import { HOM2400Component } from './modules/main/home/hom2400/hom2400.component';
import { HOM3500Component } from './modules/main/home/hom3500/hom3500.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        const langToSet = "en";
        translate.setDefaultLang(langToSet);
        translate.use(langToSet).subscribe(() => {
        }, (err) => {
          console.timeStamp(`Language initialization with '${langToSet}' .' is failed.`);
        }, () => {
          resolve(null);
        }
        );
      });
    });
}

@NgModule({
  declarations: [
    AppComponent,
    LayoutCommonComponent,
    LayoutMainComponent,
    HOM2400Component,
    HOM3500Component
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    DropDownsModule,
    AgmCoreModule.forRoot({
        // apiKey: "AIzaSyDA8YEpdGvm5HGlLOQGxj4IWpqpZXdRvtw&language=en&region=KH&callback=initMap"
    }),
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalytics.trackingID),
    CustomModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    FilesizePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [
    TranslateModule
  ],
  entryComponents: [
    HOM3500Component,
    HOM2400Component
  ],
})
export class AppModule {
  constructor() {}
}
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
